import { useState, useRef } from "react";

export function PostOptionsModal({ post, onClose, onDelete, isOwner }) {
  return (
    <div
      className="bg-white rounded-lg w-full gap-3 sm:w-96 shadow-lg overflow-y-auto"
      onClick={(e) => e.stopPropagation()}
    >
      {isOwner && (
        <>
          <button
            onClick={onDelete}
            className="w-full text-red-500 font-semibold p-3 border-b cursor-pointer hover:bg-gray-100"
          >
            Delete
          </button>
          {/* <button className="w-full py-2 border-b">Edit</button> */}
        </>
      )}
      {/* <button className="w-full py-2 border-b">Save</button> */}
      {/* <button className="w-full p-3 border-b w-full cursor-pointer hover:bg-gray-100">
        Report
      </button> */}
      <button
        onClick={onClose}
        className="w-full p-3 font-semibold text-gray-700 cursor-pointer hover:bg-gray-100"
      >
        Cancel
      </button>
    </div>
  );
}

export default PostOptionsModal;
